import { render, staticRenderFns } from "./Descuentos.vue?vue&type=template&id=01b94008"
import script from "./Descuentos.vue?vue&type=script&lang=js"
export * from "./Descuentos.vue?vue&type=script&lang=js"
import style0 from "./Descuentos.vue?vue&type=style&index=0&id=01b94008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports